import { Spinner, TextProps } from '@vtex/admin-ui'
import { styles } from './styles'

type Props = {
  variant: NonNullable<TextProps['variant']>
}

const variantSize: Record<NonNullable<TextProps['variant']>, number> = {
  body: 14,
  title1: 16,
  title2: 16,
  detail: 12,
  display: 24,
  action1: 14,
  action2: 14,
  pageTitle: 20,
}

export function TextSpinner(props: Props) {
  const { variant } = props

  return (
    <Spinner
      data-testid="spinner"
      size={variantSize[variant]}
      className={styles.spinner}
    />
  )
}
